export const appClient: 'WEB' | 'MOBILE' = 'WEB';
